import request from '@/utils/requestVr'
// 查询充值套餐列表分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/purchase/record/page',
        method: 'get',
        params: query,
    })
}
// 查询充值套餐详细
export function getObj(id) {
    return request({
        url: '/vr/storage/purchase/record/detail?id=' + id,
        method: 'get',
    })
}
// 新增充值套餐
export function addObj(data) {
    return request({
        url: '/vr/storage/purchase/record/add',
        method: 'post',
        data: data,
    })
}
// 单位自购买
export function addObjs(data) {
    return request({
        url: '/vr/storage/purchase/record/add/personal',
        method: 'post',
        data: data,
    })
}
// 修改充值套餐
export function putObj(data) {
    return request({
        url: '/vr/storage/purchase/record/edit',
        method: 'post',
        data: data,
    })
}
// 删除充值套餐
export function delObj(data) {
    return request({
        url: '/storage/purchase/record/delete',
        method: 'post',
        data: data,
    })
}

export function getDetail(params) {
  return request({
    url: '/vr/storage/purchase/record/detail',
    method: 'get',
    params,
  })
}
